/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import {
  DragDropContext,
  DropResult,
  Droppable,
  Draggable,
} from "@hello-pangea/dnd";
import Switch from "@mui/material/Switch";
import { Formik, Form } from "formik";
import LeadCaptureFormElements from "./create-lead-capture-form-elements";
import {
  StyledColumn,
  StyledList,
  StyledItem,
  StyledItemMain,
  StyledColumns,
  } from "./create-lead-capture-form-constant";
import {
  onDragEnd,
  handleClose,
  handleRequiredCheckBox,
} from "./create-lead-capture-form-helper";
import closecIcon from "../../../../assets/icons/closecIcon.svg";
import "./create-lead-capture-form.scss";
import MultiBackendWrapper from "./MultiBackendWrapper";
import { useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const CreateLeadCaptureFormDragDrop = (props: any) => {
  const { columns, setColumns, formName, setFormName, handlePreview, canWrite, isFromNewSurvey } = props;
  const initialColumns = {
  sub: {
    id: "sub",
    list: [
      {
        title: "firstName",
        id: 1,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "lastName",
        id: 3,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "email",
        id: 10,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
    ],
  },
    main: {
      id: "main",
      list: [
        { title: "primaryPhoneNumber", id: 5, isRequired: false, isShowRequired: true },
        { title: "age", id: 6, isRequired: false, isShowRequired: true },
        { title: "industry", id: 7, isRequired: false, isShowRequired: true },
        {
          title: "designation",
          id: 8,
          isRequired: false,
          isShowRequired: true,
        },
        {
          title: "interactionRate",
          id: 9,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "againIn",
          id: 10,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "customerSupport",
          id: 11,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "product",
          id: 12,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "purchasedFor",
          id: 13,
          isRequired: false,
          isShowRequired: true,
        },
        {
          title: "address",
          id: 14,
          isRequired: false,
          isShowRequired: true,
        },

        // { title: "city", id: 17, isRequired: false, isShowRequired: true },
        // { title: "state", id: 18, isRequired: false, isShowRequired: true },
        // { title: "country", id: 19, isRequired: false, isShowRequired: true },
        // { title: "zipcode", id: 20, isRequired: false, isShowRequired: true },
        // {
        //   title: "description",
        //   id: 21,
        //   isRequired: false,
        //   isShowRequired: true,
        // },
      ],
    },
};
const theme = useTheme(); // Get theme from context
const isMobile = useMediaQuery(theme?.breakpoints?.down("sm") || "(max-width:600px)");
  return (
    <>
      <div className="lead-capture-form-filter-wrapper">
        <Formik
          initialValues={{}}
          enableReinitialize={true}
          onSubmit={() => {}}
        >
          {() => (
            <Form>
              <MultiBackendWrapper>
              <DragDropContext
                onDragEnd={({ source, destination }: DropResult) =>
                  onDragEnd(source, destination, columns, setColumns)
                }
              >
                <StyledColumns className="lead-capture-form-columns-wrapper">
                  {Object.values(columns).map((col: any) =>
                    col?.id === "sub" ? (
                      <Droppable droppableId={col?.id} key={col?.id}>
                        {(provided) => (
                          <StyledColumn className="lead-capture-form-columns-wrapper-element-one">
                            <StyledList
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              <div className="lead-capture-form-sub">
                                <input
                                  placeholder="Enter Title"
                                  className={`lead-capture-form-sub-title ${
                                    props.isEdit && formName ? 'disabled' : ''
                                  }`}
                                  type="text"
                                  value={formName}
                                  onChange={(e: any) => {
                                    setFormName(e?.target?.value);
                                  }}
                                  disabled={props.isEdit && formName}
                                />
                                <div className="lead-capture-form-sub-element">
                                  {col?.list?.map((data: any, index: any) => (
                                    <Draggable
                                      draggableId={data?.title}
                                      index={index}
                                      key={data?.title}
                                    >
                                      {(provided) => (
                                        <StyledItem
                                          ref={provided.innerRef}
                                          {...(!data?.showClose
                                            ? {
                                                ...provided.draggableProps,
                                                ...provided.dragHandleProps,
                                              }
                                            : {})}
                                        >
                                          <div className="lead-capture-form-sub-element-close-section">
                                            {!data?.showClose ? (
                                              <div className="lead-capture-form-sub-element-close">
                                                <img
                                                  onClick={() => {
                                                    handleClose(
                                                      data,
                                                      col,
                                                      index,
                                                      columns,
                                                      setColumns,
                                                    );
                                                  }}
                                                  src={closecIcon}
                                                  className="lead-capture-form-sub-element-close"
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            <LeadCaptureFormElements
                                              data={data}
                                            />
                                            {data?.isShowRequired ? (
                                              <div className="lead-capture-form-sub-element-required">
                                                <div className="lead-capture-form-sub-element-required-text">
                                                  Required field
                                                </div>
                                                <div className="lead-capture-form-sub-element-required-button">
                                                  <Switch
                                                    inputProps={{
                                                      "aria-label":
                                                        "Color switch demo",
                                                    }}
                                                    onChange={() => {
                                                      handleRequiredCheckBox(
                                                        data,
                                                        col,
                                                        columns,
                                                        setColumns,
                                                      );
                                                    }}
                                                    value={data?.isRequired}
                                                    checked={data?.isRequired}
                                                  />
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </StyledItem>
                                      )}
                                    </Draggable>
                                  ))}
                                  {col?.list?.length === 0 && (
                                    <div className="lead-capture-form-sub-element-empty">
                                      Drag and drop fields to start building
                                      your form.
                                    </div>
                                  )}
                                </div>
                                <div className="lead-capture-form-sub-element-add-reset-button-section">
                                  <button
                                    type="button"
                                    className="lead-capture-form-sub-element-reset-button"
                                    disabled={col?.list?.length === 0}
                                    onClick={() =>{
                                      setColumns(initialColumns)
                                       setFormName("");
                                    }
                                    }
                                  >
                                    Reset
                                  </button>
                                  <button
                                    type="button"
                                    onClick={handlePreview}
                                    className="lead-capture-form-sub-element-add-button"
                                    disabled={col?.list?.length === 0 || (!canWrite && isFromNewSurvey)}
                                  >
                                    Preview
                                  </button>
                                </div>
                              </div>
                              {provided.placeholder}
                            </StyledList>
                          </StyledColumn>
                        )}
                      </Droppable>
                    ) : (
                      <Droppable droppableId={col?.id} key={col?.id}>
                        {(provided) => (
                          <StyledColumn className="lead-capture-form-columns-wrapper-element-two">
                            <StyledList
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              className="lead-capture-form-columns-wrapper-element-two-box"
                            >
                              <div className="lead-capture-form-main">
                                <div className="lead-capture-form-main-title">
                                  <div className="lead-capture-form-main-title-text-main">
                                    Fields
                                  </div>
                                  <div className="lead-capture-form-main-title-text-sub">
                                    Drag and drop fields to start building your
                                    form.
                                  </div>
                                </div>
                                <div className="lead-capture-form-main-element">
                                  {col?.list?.map((data: any, index: any) => (
                                    <Draggable
                                      draggableId={data?.title}
                                      index={index}
                                      key={data?.title}
                                    >
                                      {(provided) => (
                                        <StyledItemMain
                                          mobile={isMobile}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                        >
                                          <LeadCaptureFormElements
                                            data={data}
                                          />
                                        </StyledItemMain>
                                      )}
                                    </Draggable>
                                  ))}
                                </div>
                              </div>
                              {provided.placeholder}
                            </StyledList>
                          </StyledColumn>
                        )}
                      </Droppable>
                    ),
                  )}
                </StyledColumns>
              </DragDropContext>
              </MultiBackendWrapper>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default CreateLeadCaptureFormDragDrop;
